import React, { useContext, useEffect } from 'react';
import ExpandCollapse from '../../common/ExpandCollapse';
import GoUpParag from '../../common/GoUpParag';
import MatchAgg from '../../common/MatchAgg';
import MatchBet from '../../common/MatchBet';
import MessageInfo from '../../common/MessageInfo';
import MainContext from '../../contexts/MainContext';
import { MAX_COLUMNS } from '../../data/constants';
import { classIf, getConfiguration, getMatchIdOrStageId, iconSportCssClass } from '../../data/utils';
import BetGeniusWidget from '../../data/widgets/BetGeniusWidget';
import FlashbetWidget from '../../data/widgets/FlashbetWidget';
import StatsCoreWidget from '../../data/widgets/StatsCoreWidget';
import { bgWidgetEnabled, brWidgetS5Enabled, getBetgeniustWidgetUrl, getFlashbetWidgetUrl, statsCoreWidgetEnabled, STATSCORE_WIDGET_LIVESCORE, WidgetContext } from '../../data/widgets/WidgetContext';
import { getLabel } from '../../data/labels';
import ButtonsContainer from '../../prematch/prematch-home/ButtonsContainer';
import Streaming from '../common/Streaming';
import Jersey from '../../data/jerseys/Jersey';
import StatsToggle from '../../common/StatsToggle';
import { systemCode } from '../..';
import { useUISettingsDispatch } from '../../UISettingsProvider';

function Competition(props) {
    const conf = getConfiguration();
    const mainContext = useContext(MainContext);
    const widgetContext = React.useContext(WidgetContext);
    const isBrWidgetS5 = brWidgetS5Enabled(props.sportRef, props.widgetType);
    const isBetgeniusWidget = bgWidgetEnabled(props.sportRef, props.widgetType, props.geniusId);
    const isStatsCoreWidget = statsCoreWidgetEnabled(STATSCORE_WIDGET_LIVESCORE, widgetContext.widgetProviderType, props.lsportWidgetId);
    const flashbetWidgetUrl = getFlashbetWidgetUrl(props.widgetType);
    const gruppiScommessa = props.macrogruppo != null ? props.macrogruppo.aggregate : props.gruppiScommessa;
    const agg = props.gruppoById[props.aggregata];
    let bets = props.bets.filter(bet => bet.hasOdds === true);

    let showAgg = false;
    if (props.betsById.size === 0) {
        let nOdds = 0;
        bets.forEach(bet => {
            nOdds += bet.odds.length;
        });
        if (nOdds > MAX_COLUMNS) {
            showAgg = true;
        }
    }


    // TODO usa un id come chiave
    const aggregateBtns = gruppiScommessa.map(function (betGroup, i) {
        function handleClick() {
            props.setAggregata(betGroup.idAggregata);
        }
        const selected = betGroup.idAggregata === props.aggregata;

        return (
            <div key={betGroup.idAggregata} data-id={`a-${betGroup.idAggregata}`} className={"bg-bianco nero bordo-tondo elemento-macro pointer filter" + classIf(selected, 'icona-selezionata agg-selezionata')} onClick={handleClick}>{betGroup.descrizione}</div>
        );
    });

    const macrogruppiBtns = props.macrogruppi && props.macrogruppi.map(function (mg) {
        function handleClick() {
            props.setMacrogruppo(mg);
        }
        return <div key={mg.id} data-id={`m-${mg.id}`} className={"bordo-tondo elemento-macro pointer" + classIf(props.macrogruppo && (props.macrogruppo.id === mg.id), 'icona-selezionata agg-selezionata')} onClick={handleClick}>{mg.descrizione}</div>
    });

    useEffect(function () {
        if (!props.isLive) {
            widgetContext.setWidget({
                widgetMatchId: getMatchIdOrStageId(props),
                widgetLsportId: props.lsportWidgetId,
                widgetProviderType: props.widgetType,
                widgetContainerId: '#collassaWidgetCompetition',
                widgetStartCollapsed: true,
                widgetGeniusId: props.geniusId,
                widgetSportId: props.sportRef,
            });
        }

        return function () {
            if (conf.lstwc) {
                mainContext.setStreamingContainer('betradar-widget');
            } else {
                mainContext.toggleStreaming(null, null, null);
            }

            const settings = {
                isWidgetToggleable: true
            };
            if (!props.isLiveSuite) {
                Object.assign(settings, {
                    widgetMatchId: null,
                    widgetLsportId: null,
                    widgetProviderType: null
                });
            }
            widgetContext.setWidget(settings);
        };
    }, [props.isLive, props.id]);

    const icoSport = iconSportCssClass(props.sportRef, props.iconClass);
    const macrogruppiMaxNumOfRows = (conf.iwh || systemCode === 'STARCASINO') ? 1 : 3;
    const aggregateMaxNumOfRows = 1
    const dispatch = useUISettingsDispatch();

        function handleFullScreen() {
            dispatch({type: 'toggleFullscreen'});
        }

    return (
        <>
            <div className="titolo-blocco-sport bg-nero bianco">
                <div className="d-flex justify-content-between align-items-center w-100" >
                    {props.isLive &&
                        <div className={`img-fluid ico-sport mr-1 ${icoSport}`}></div>
                    }
                    <div className="d-flex flex-column">
                        <div className="d-flex items-center">
                            {props.team2 &&
                                <Jersey data={props.jerseys?.[0]} type={'home'} sportRef={props.sportRef} />
                            }
                            <p className="nome-partita-sport">{props.team1}</p>
                        </div>
                        {props.team2 &&
                            <div className="d-flex items-center">
                                <Jersey data={props.jerseys?.[1]} type={'away'} sportRef={props.sportRef} />
                                <p className="nome-partita-sport">{props.team2}</p>
                            </div>
                        }
                    </div>
                    <p className="data-orario-partita-sport d-flex justify-content-end align-items-center margine-sx">
                        {props.date} {props.time}
                        <StatsToggle className="fas fa-chart-bar stat-sel margine-sx-mezzo grigio pointer" match={props} />
                        {(systemCode === 'STARCASINO' || conf.iwh) && <i className='close--sidebar fa fa-times' onClick={handleFullScreen}></i>}
                    </p>
                </div>
            </div>
            <Streaming container="competition" />
            {widgetContext.widgetMatchId != null && widgetContext.widgetContainerId === '#collassaWidgetCompetition' &&
                <div className={`widget-filtro-side margine-giu live-tracker-widget ${isBetgeniusWidget ? 'betgeniusWidget' : ''}`}>
                    {flashbetWidgetUrl ?
                        <FlashbetWidget url={flashbetWidgetUrl} />
                        :
                        isBetgeniusWidget ?
                            <BetGeniusWidget url={getBetgeniustWidgetUrl(props.sportRef, props.categoryRef, props.tournamentRef)} />
                            :
                            isStatsCoreWidget ?
                                <StatsCoreWidget />
                                :
                                <div className={`bordato-widget bg-nero ${isBrWidgetS5 ? 'brWidgetS5' : ''} `} id="collassaWidgetCompetition"></div>
                    }
                </div>
            }
            {props.giocabilita !== undefined && !props.giocabilita ?
                <MessageInfo message={getLabel('general.giocabilita_chiusa')} />
                :
                <>
                    {((props.macrogruppi && props.macrogruppi.length > 1) || (gruppiScommessa && aggregateBtns.length > 1)) &&
                        <div className="macro-gruppi buttonsContainerAlt-altre">
                            {props.macrogruppi && props.macrogruppi.length > 1 &&
                                   ((systemCode === 'STARCASINO' || conf.iwh ) ?
                                        <ButtonsContainer id={props.macrogruppo ? props.macrogruppo.id : null} buttons={macrogruppiBtns} aggregate={false} forceRows={false} maxNumOfRows={macrogruppiMaxNumOfRows} scrollOffset={150} />
                                        :
                                        <ButtonsContainer id={props.macrogruppo ? props.macrogruppo.id : null} buttons={macrogruppiBtns} aggregate={false} forceRows={true} />
                                    )
                            }
                            {gruppiScommessa && aggregateBtns.length > 1 &&
                                 ((conf.iwh) ?
                                    <ButtonsContainer id={props.aggregata} buttons={aggregateBtns} aggregate={true} forceRows={false} maxNumOfRows={aggregateMaxNumOfRows} scrollOffset={150} />
                                    : 
                                    <ButtonsContainer id={props.aggregata} buttons={aggregateBtns} aggregate={true} forceRows={true} />
                                 ) 
                            }
                        </div>
                    }
                    <ExpandCollapse key={(props.macrogruppo && props.macrogruppo.id) || props.aggregata} />
                    <div className="colonne-evento-live d-grid unaColonna">
                        {showAgg ?
                            <MatchAgg bets={bets} desc={agg.descrizione} />
                            :
                            (bets.map(function (bet) {
                                const id = `${bet.id}_${bet.handicap}`;
                                return (
                                    <MatchBet key={id} {...bet} expanded={true} />
                                );
                            }))
                        }
                    </div>
                    <GoUpParag />
                </>
            }
        </>
    );
}

export default Competition;